import { render, staticRenderFns } from "./MoreForVR.vue?vue&type=template&id=84afdbd2&scoped=true"
import script from "./MoreForVR.vue?vue&type=script&lang=js"
export * from "./MoreForVR.vue?vue&type=script&lang=js"
import style0 from "./MoreForVR.vue?vue&type=style&index=0&id=84afdbd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84afdbd2",
  null
  
)

export default component.exports